import * as React from "react";
import { useTranslation } from "react-i18next";
import { PageHeader, DocumentTitle, Spinner } from "components/common";
import DocsHelper from "util/DocsHelper";
import UserSearchFilterCreate from "search-filter/components/filter-management-pages/UserSearchFilterCreate";
import SearchFiltersPageSubactions from "search-filter/components/filter-management-pages/SearchFiltersPageSubactions";
import { InvalidLicenseWarning } from "license/LicenseCheck";
import useSearchFilterLicenseStatus from "search-filter/hooks/useSearchFilterLicenseStatus";
const MyFiltersOverviewPage = () => {
  const { isFetchingLicense, isValidLicense } = useSearchFilterLicenseStatus();
  const { t } = useTranslation("enterprise_search");
  if (isFetchingLicense) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("my_filters_create_page.document_title") }, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: t("my_filters_create_page.title"),
      actions: /* @__PURE__ */ React.createElement(SearchFiltersPageSubactions, { licenseIsValid: isValidLicense }),
      documentationLink: {
        title: t("my_filters_create_page.docs_title"),
        path: DocsHelper.PAGES.SEARCH_FILTERS
      }
    },
    /* @__PURE__ */ React.createElement("span", null, t("my_filters_create_page.description"))
  ), isValidLicense ? /* @__PURE__ */ React.createElement(UserSearchFilterCreate, null) : /* @__PURE__ */ React.createElement(
    InvalidLicenseWarning,
    {
      featureName: t("my_filters_create_page.feature_name"),
      licenseSubject: "/license/enterprise/search-filter",
      displayWarningContainer: true
    }
  ));
};
export default MyFiltersOverviewPage;
